import React, { useContext, useState } from "react";

import { useAppStore } from "../../../../../context/store";
import { Dialog, Portal, Select, HStack, CloseButton, Button, useSelectContext, Text, createListCollection } from "@chakra-ui/react";

import { convertGeoJsonToKml, downloadGeoJSON, downloadKML } from "../../../../../utilies/Utility";
import { getEditedGeoJSON } from "../../../../../utilies/geojson/GetEditedGeojson";

const LayersExport = () => {
  // state
  const exportDialog = useAppStore((s) => s.exportDialog);
  const currentLayer = useAppStore((s) => s.currentLayer);

  // setters
  const setExportDialog = useAppStore.getState().setExportDialog;
  const setCurrentLayer = useAppStore.getState().setCurrentLayer;

  const [selectedType, setSelectedType] = useState("Geojson");
  const TypeSelectValue = () => {
    const select = useSelectContext();
    const items = select.selectedItems;
    if (items.length !== 0) {
      const { name } = items[0];
      return (
        <Select.ValueText placeholder="Select member">
          <HStack>{name}</HStack>
        </Select.ValueText>
      );
    }
  };

  const exportOption = createListCollection({
    items: [
      {
        name: "Geojson",
      },
      {
        name: "KML",
      },
    ],
    itemToString: (item) => item.name,
    itemToValue: (item) => item.name,
  });

  const exportAsset = () => {
    switch (selectedType) {
      case "Geojson":
        if (currentLayer.view_type == "line") {
          downloadGeoJSON(getEditedGeoJSON(currentLayer), currentLayer.file_name);
        } else {
          downloadGeoJSON(currentLayer.osmGeojson, currentLayer.file_name);
        }
        break;
      case "KML":
        if (currentLayer.view_type == "line") {
          downloadKML(convertGeoJsonToKml(getEditedGeoJSON(currentLayer)), currentLayer.file_name);
        }
        break;
    }
    setExportDialog(false);
  };

  return (
    <Dialog.Root
      lazyMount
      size={"sm"}
      open={exportDialog}
      onOpenChange={(e) => {
        setExportDialog(e.open);
        if (!Boolean(e.open)) {
          setCurrentLayer(null);
        }
      }}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title> </Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Text>Select the export type</Text>
              <Select.Root
                collection={exportOption}
                size="sm"
                defaultValue={[selectedType]}
                positioning={{ sameWidth: true }}
                onValueChange={(v) => {
                  setSelectedType(v.value[0]);
                }}
              >
                <Select.HiddenSelect />
                <Select.Control>
                  <Select.Trigger>
                    <TypeSelectValue />
                  </Select.Trigger>
                  <Select.IndicatorGroup>
                    <Select.Indicator />
                  </Select.IndicatorGroup>
                </Select.Control>
                <Select.Positioner>
                  <Select.Content>
                    {exportOption.items.map((item) => (
                      <Select.Item item={item} key={item.name} justifyContent="flex-start">
                        {item.name}
                        <Select.ItemIndicator />
                      </Select.Item>
                    ))}
                  </Select.Content>
                </Select.Positioner>
              </Select.Root>
            </Dialog.Body>
            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline">Cancel</Button>
              </Dialog.ActionTrigger>
              <Button
                onClick={() => {
                  exportAsset();
                }}
              >
                Export
              </Button>
            </Dialog.Footer>
            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default LayersExport;
